<div class="modal fade show" style="display: block;" id="exampleModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-dark">
            <div class="row" id="modal-header">
                <div class="col-md-4 ml-auto">
                    <button type="button" id="close-btn" class="close" data-dismiss="modal" aria-label="Close" (click)="cleanSRC()"><span class="text-light"aria-hidden="true">&times;</span></button>
                </div>
            </div>

            <div class="modal-body">
                <div class="embed-container" *ngIf="ytSrc!='NA'">
                    <iframe height="320" width="640" frameborder="0" [src]="ytSrc | safe" allowfullscreen></iframe>
                </div>
                <span class="text-light" *ngIf="vLoading">Cargando video, por favor espere...</span>
                <span class="text-light" *ngIf="vNotAv">Video no disponible, lo sentimos :'(</span>
            </div>
        </div>
    </div>
</div>